module.exports = __webpack_public_path__ + "static/media/grey_logo.6e666a16.png";